import { atom, getDefaultStore } from "jotai";

const store = getDefaultStore();
export const scenariosAtom = atom<string[]>([]);

const get = () => store.get(scenariosAtom);

const set = (scenarios: string[]) => store.set(scenariosAtom, scenarios);

const add = (scenario: string) => store.set(scenariosAtom, [...store.get(scenariosAtom), scenario]);

const remove = (name: string) =>
{
	store.set(scenariosAtom, store.get(scenariosAtom).filter(s => s !== name));
};

const clear = () => store.set(scenariosAtom, []);

export const scenarioStore = {
	get,
	set,
	add,
	remove,
	clear,
};
